module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-page"
  }, [_c('div', {
    staticClass: "contect-icon"
  }, [_c('img', {
    staticClass: "weibo-icon",
    attrs: {
      "src": require("../assets/weibo.svg"),
      "alt": ""
    }
  }), _c('img', {
    attrs: {
      "src": require("../assets/weixin.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "support-company"
  }, [_c('label', [_vm._v("Copyright © 2017. All Rights Reserved.上海拓体信息技术有限公司提供技术支持")])]), _c('div', {
    staticClass: "doc"
  }, [_vm._v("京ICP备14041720号-1京ICP证140622号京公网安备11010502025474")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40c2c5ce","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 570
// module chunks = 85